import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';

import {SharedModule} from '../shared/shared.module';
import {MediaCarouselModule} from '../media-carousel/media-carousel.module';
import {ObjectEditModule} from '../object-edit/object-edit.module';
import {AdminImportAuthoritiesComponent} from './admin-import-authorities/admin-import-authorities.component';
import {ObjectViewModule} from '../object-view/object-view.module';
import {ObjectSearchModule} from '../object-search/object-search.module';
import {OverviewFieldsModule} from '../overview-fields/overview-fields.module';
import {ImportSitulaComponent} from './import-situla/import-situla.component';
import {MediaSelectorModule} from '../media-selector/media-selector.module';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';
import {OperationsModule} from '../operations/operations.module';
import {MatLegacySliderModule as MatSliderModule} from '@angular/material/legacy-slider';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {ObjectContentTabModule} from '../object-content-tab/object-content-tab.module';
// eslint-disable-next-line max-len

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MatDialogModule,
        MatTableModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSliderModule,
        MatIconModule,
        SharedModule,
        MediaCarouselModule,
        ObjectEditModule,
        ObjectViewModule,
        ObjectSearchModule,
        OverviewFieldsModule,
        MediaSelectorModule,
        OperationsModule,
        MatFormFieldModule,
        MatInputModule,
        ObjectContentTabModule,
    ],
  declarations: [
    AdminImportAuthoritiesComponent,
    ImportSitulaComponent,
  ]
})
export class LandingPagesModule {
}
